module.exports = __webpack_public_path__ + "img/desk3.8c8e249f.png";